export const SET_LOADING = "SET_LOADING";
export const LIST_PENGAJUAN_PPBJ = "LIST_PENGAJUAN_PPBJ";
export const LIST_PENGAJUAN_PTUM = "LIST_PENGAJUAN_PTUM";
export const LIST_PENGAJUAN_BKKB = "LIST_PENGAJUAN_BKKB";
export const LIST_PENGAJUAN_BTKB = "LIST_PENGAJUAN_BTKB";
export const LIST_PENGAJUAN_BJ = "LIST_PENGAJUAN_BJ";
export const DETAIL_PENGAJUAN = "DETAIL_PENGAJUAN";